import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import Form from 'dashboard/layouts/FormLayout/Form';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import PiiAttributes from 'lib/interfaces/PiiAttributes';
import { isRequired, withMessage } from 'lib/utils/formValidation';

const validate = {
  term: [withMessage('Please enter a name', isRequired)],
};

interface FormCreateReportBusinessAdverseMediaProps {
  handleCancel: () => void;
  readOnly?: boolean;
}

const FormCreateReportBusinessAdverseMedia = ({
  submitting,
  pristine,
  handleSubmit,
  handleCancel,
  readOnly,
}: FormCreateReportBusinessAdverseMediaProps &
  InjectedFormProps<
    FormCreateReportBusinessAdverseMediaData,
    FormCreateReportBusinessAdverseMediaProps
  >) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Field
        id='create-report-business-adverse-media__term'
        label='Name'
        name='term'
        component={InputField}
        disabled={submitting || readOnly}
        data-test='create-report-business-adverse-media__term'
        validate={validate['term']}
        placeholder='Name'
      />
      <HStack equal={true}>
        <Button
          variant='basic'
          id='create-report-business-adverse-media__cancel'
          data-test='create-report-business-adverse-media__cancel'
          disabled={submitting}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          data-test='create-report-business-adverse-media__submit'
          disabled={submitting || pristine}
          isPending={submitting}
        >
          Create Report
        </Button>
      </HStack>
    </Form>
  );
};

export interface FormCreateReportBusinessAdverseMediaData {
  term?: string;
  [PiiAttributes.CountryCode]?: string;
}

export const FORM_CREATE_REPORT_BUSINESS_ADVERSE_MEDIA_NAME =
  'formCreateReportBusinessAdverseMediaData';

export default reduxForm<
  FormCreateReportBusinessAdverseMediaData,
  FormCreateReportBusinessAdverseMediaProps
>({
  form: FORM_CREATE_REPORT_BUSINESS_ADVERSE_MEDIA_NAME,
})(FormCreateReportBusinessAdverseMedia);
